<template>
  <b-card
    bg-variant="light"
    class="book-card my-3"
    @click="goToBookDetail(book.id)"
  >
    <img class="book-image" :src="book.imageURL" :title="book.bookTitle" />
    <b-card class="book-info my-3">
      {{ book.bookTitle }}<br />
      {{ book.author }}
    </b-card>
  </b-card>
</template>

<script>
// import { db } from "@/firebase";

export default {
  props: ["book"],
  // {
  //   bookTitle,
  //   author,
  //   imageURL
  // }
  methods: {
    goToBookDetail(id) {
      this.$router.push("/book/" + id);
    }
  }
};
</script>

<style lang="scss">
.book-image {
  box-shadow: 0 15px 30px -5px rgba(0, 0, 0, 0.15), 0 0 5px rgba(0, 0, 0, 0.1);
}
.book-card:hover {
  box-shadow: 0 15px 30px -5px rgba(0, 0, 0, 0.15), 0 0 5px rgba(0, 0, 0, 0.1);
  transform: translateY(-4px);
}
.book-card {
  width: 270px;
  height: 350px;
  margin: 0 1.5%;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.12), 0 2px 3px 0 rgba(0, 0, 0, 0.22);
  transition: 0.3s;
}
.book-info {
  font-size: 14px;
}
</style>
